import { handleActions } from 'redux-actions';

import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';

export const initialState = {
  firstName: '',
  lastName: '',
  isLeadCreated: false,
  errorMessage: '',
};

const reducer = handleActions(
  {
    [actionTypes.UPDATE_ERROR_MESSAGE]: (state, { payload }) => ({
      ...state,
      isLeadCreated: false,
      errorMessage: payload,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX),
);

export default reducer;
